var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgRankingNum4 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.928 37.068c.56 0 .84.28.84.84v5.628c0 .56-.28.84-.84.84H26.24c-.224 0-.336.112-.336.336V59.16c0 .56-.28.84-.84.84H18.68c-.56 0-.84-.28-.84-.84V44.712c0-.224-.112-.336-.336-.336H.84c-.56 0-.84-.28-.84-.84v-4.704c0-.224.056-.56.168-1.008L10.264 1.872c.168-.448.504-.672 1.008-.672h6.888c.616 0 .84.308.672.924L9.408 36.648a.357.357 0 0 0 0 .336.746.746 0 0 0 .336.084h7.76c.224 0 .336-.112.336-.336V25.224c0-.56.28-.84.84-.84h6.384c.56 0 .84.28.84.84v11.508c0 .224.112.336.336.336h2.688Z"
  })));
});
SvgRankingNum4.displayName = "SvgRankingNum4";
export default SvgRankingNum4;